module.exports = __webpack_public_path__ + "img/sock.9eb419f7.svg";